import React from 'react';

// The tail of a History list paged on the server: a button for the next page, or a loading line
// while the first one is in flight. Renders nothing once the server has no more rows.

export interface LoadMoreProps {
  hasMore?: boolean;
  isLoading?: boolean;
  /** The last page request failed: the button stays, as the retry. */
  isError?: boolean;
  onLoadMore?: () => void;
  label: string;
}

export const LoadMore: React.FC<LoadMoreProps> = ({
  hasMore,
  isLoading,
  isError,
  onLoadMore,
  label,
}) => {
  if (!hasMore || !onLoadMore) {
    return isLoading ? (
      <p className="px-[18px] py-3 text-xs text-lr-faint" role="status">
        Loading…
      </p>
    ) : null;
  }
  return (
    <div className="px-[18px] py-3">
      {isError && !isLoading && (
        <p className="mb-2 text-xs text-red-600" role="alert">
          Could not load more, try again.
        </p>
      )}
      {/* Stays mounted while the next page loads, so keyboard focus stays on it. */}
      <button
        type="button"
        aria-disabled={isLoading || undefined}
        onClick={isLoading ? undefined : onLoadMore}
        className="rounded-[7px] border border-lr-border px-3 py-1.5 text-xs font-semibold text-lr-fg-2 hover:bg-lr-surface-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-lr-accent aria-disabled:cursor-default aria-disabled:opacity-60"
      >
        {isLoading ? 'Loading…' : label}
      </button>
    </div>
  );
};
